<script>
/**
 * Stat component -- specify the widget icon, title and value.
 */
export default {
  props: {
    title: {
      // type: String,
      default: '',
    },
    subTitle: {
      // type: String,
      default: '',
    },
    value: {
      // type: String,
      default: '',
    },
    icon: {
      // type: String,
      default: '',
    },
    color: {
      default: '',
    },
  },
};
</script>

<template>
  <div class="card mini-stats-wid">
    <div class="card-body">
      <div class="media">
        <div class="media-body">
          <p class="text-muted font-weight-medium mb-0">
            {{ title }}
          </p>
          <p
            :v-bind:class="subTitle == '' ? 'hidden' : null"
            class="text-muted font-weight-light"
          >
            {{ subTitle }}
          </p>
          <h4 class="mb-0" :style="{ color: `${color}` }">{{ value }}</h4>
        </div>

        <div
          class="mini-stat-icon avatar-sm align-self-center rounded-circle bg-primary"
        >
          <span class="avatar-title">
            <i :class="`${icon} font-size-24`"></i>
          </span>
        </div>
      </div>
    </div>
    <!-- end card-body -->
  </div>
  <!-- end card -->
</template>
